let _externalModalSetter: ((value: boolean) => void) | null = null;

export const registerSessionModalSetter = (setter: (value: boolean) => void) => {
  _externalModalSetter = setter;
};

export const setSessionExpiredModalState = (value: boolean) => {
  if (_externalModalSetter) _externalModalSetter(value);
};
